import { Customer } from "@app/models/customer";

/**
 * Regra de negócio: o usuário nunca pode ter pontos negativos.
 *
 * Qualquer valor de pontos vindo do backend (null, undefined, ausente, string
 * inválida ou negativo por erro) é normalizado para 0 antes de chegar na UI.
 */
export function safePoints(value: unknown): number {
  const points = Number(value);
  if (!Number.isFinite(points) || points <= 0) {
    return 0;
  }
  return points;
}

/**
 * Retorna uma cópia do customer com todos os saldos normalizados (>= 0).
 * Usado no ponto de entrada do estado (SharedService) para que APP e WEB
 * consumam sempre valores já saneados.
 */
export function normalizeCustomerBalances(customer?: Customer): Customer | undefined {
  if (!customer) {
    return customer;
  }
  return {
    ...customer,
    balanceProcessed: safePoints(customer.balanceProcessed),
    balanceAvailable: safePoints(customer.balanceAvailable),
    balanceExpired: safePoints(customer.balanceExpired),
    balanceRedeem: safePoints(customer.balanceRedeem),
  };
}
